/**
 * Hands a blob to the browser as a download.
 *
 * The object URL is revoked immediately after the click: the browser has
 * already taken its own reference by then, and holding ours would keep the
 * whole file alive for the life of the page.
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(blob);
  try {
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}

/** Saves a data URL (a canvas screenshot, for one) under `fileName`. */
export function saveDataUrl(dataUrl: string, fileName: string): void {
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
}
